import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=05c339da&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports